import { useState } from "react";
import { faqItems } from "@/mocks/homeContent";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Everything you need to know about the Mulebuy Spreadsheet system.
          </p>
        </div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqItems.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200 overflow-hidden"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between px-4 md:px-5 py-3 md:py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span
                  className="text-sm md:text-base font-medium text-foreground-900 pr-4"
                  itemProp="name"
                >
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-200 shrink-0 ${
                    openIndex === idx ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === idx ? "max-h-96" : "max-h-0"
                }`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <div className="px-4 md:px-5 pb-3 md:pb-4" itemProp="text">
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}